// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { get, getErrorMessage, post } from '../../../utils/api-utils'
import { displayApiError } from '../../../utils/error-handling-utils'
import { getAccessRules } from '../../../utils/manage-account-utils'
import { getCustomerAccountType } from '../../../utils/feature-flag-utils'
import { displayNotification } from '../../../utils/notificiation-utils'
import Markdown from '../../Markdown'

export const fetchWorkspaceHelper = ({
  isTenantWorkspaceGroup,
  tenantIds,
  oidcUser,
  pcid,
  setselectedWorkspaceIds,
  setWorkspaceGroup,
  setShowWorkspaceModal,
  setShowErrorNotification,
  commonT
}) => {
  if (isTenantWorkspaceGroup) {
    let queryParams = '?group-type=Workspace'

    if (tenantIds) {
      tenantIds?.forEach((tenantId) => {
        queryParams += `&group-ids=${tenantId}`
      })
    }
    get(
      `/groups-management/v1alpha1/groups${queryParams}`,
      null,
      oidcUser.access_token,
      false,
      {},
      { 'X-workspaceID': pcid }
    ).then(
      (response) => {
        if (tenantIds) {
          setselectedWorkspaceIds(response?.data?.items ?? [])
          setShowWorkspaceModal(true)
        } else {
          setWorkspaceGroup(response?.data?.items ?? [])
        }
      },
      (error) => {
        setShowErrorNotification(
          displayApiError(error, commonT, setShowErrorNotification)
        )
      }
    )
  }
}

export const getUserFullName = (firstName, lastName, email) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  }
  return firstName || lastName || email || ''
}

export const getSubTitle = (newDashboardFlag, isbulkInvite, user, authnT) => {
  let subtitle = ''
  if (newDashboardFlag) {
    subtitle = authnT('users.user_role_assignments_service_subheading')
  } else if (isbulkInvite) {
    subtitle = `Review roles to be assigned copied from ${getUserFullName(
      user?.first_name,
      user?.last_name,
      user?.email
    )}`
  } else {
    subtitle = authnT('users.user_role_assignments_subheading')
  }
  return subtitle
}

export const setAccessRules = ({
  isMSPUserInviteOrGlop,
  isTenantWorkspaceGroup,
  formValues
}) => {
  const accountType = getCustomerAccountType()
  let accessRuleValue
  if (isMSPUserInviteOrGlop && isTenantWorkspaceGroup) {
    accessRuleValue = {
      msp: true,
      tenants: formValues?.access_rules?.tenants
    }
  } else if (accountType === 'MSP') {
    accessRuleValue =
      isMSPUserInviteOrGlop && !isTenantWorkspaceGroup
        ? formValues?.access_rules
        : getAccessRules(0)
  } else {
    accessRuleValue = null
  }
  return accessRuleValue
}

export const assignRole = ({
  formValues,
  rolesList,
  isMSPUserInviteOrGlop,
  isTenantWorkspaceGroup,
  setIsSubmitting,
  LDFlags,
  containGLC,
  oidcUser,
  onSetOpen,
  onSuccess,
  setShowNotification,
  authnT,
  setErrorOccurred
}) => {
  const { email, role, contact_info } = formValues
  const selectedRole = rolesList.find((roleName) => roleName.slug === role.slug)
  const requestBody = {
    roles: [
      {
        role: {
          application_id: selectedRole.applicationId,
          slug: selectedRole.slug
        },
        access_rules: setAccessRules({
          isMSPUserInviteOrGlop,
          isTenantWorkspaceGroup,
          formValues
        })
      }
    ],
    user_names: [email],
    ...(contact_info.length && {
      contact_information: contact_info
    })
    // send platform_customer_id and customer_username fileds for ccs-manager API
  }
  setIsSubmitting(true)
  let url = `/ui-doorway/ui/v1/um/invite-user`
  if (LDFlags['glcp-glc-migration'] && containGLC) {
    url = '/organizations/v1alpha1/users/invite-user'
  }
  post(url, requestBody, oidcUser.access_token).then(
    (response) => {
      if (response.status === 200) {
        onSetOpen(false)
        onSuccess()
        setShowNotification(
          displayNotification(
            <Markdown>
              {authnT('users.user_invite_notification_msg', {
                userName: requestBody?.user_names[0]
              })}
            </Markdown>,
            'info',
            setShowNotification,
            authnT('users.user_invite_notification_title')
          )
        )
      }
    },
    (error) => {
      const backendErrorMessage = getErrorMessage(error, authnT)
      setErrorOccurred(backendErrorMessage)
      setIsSubmitting(false)
    }
  )
}
